import {React, Component, Container, Config} from 'utils';
import {withRouter} from 'react-router-dom';
import {App, Creators, SelectedPavilionStore, GalleryStore} from 'model';
import './gallery.less'
import SwiperFull, {Element} from './swiper-full';

class Gallery extends Component {

	static getStores() {
		return [SelectedPavilionStore, GalleryStore];
	}

	static calculateState(state, props) {
		var selected_pavilion = SelectedPavilionStore.getSelectedPavilion();
		var gallery_data = GalleryStore.getState().data;
		return {selected_pavilion, gallery_data};
	}

	componentDidMount() {
		var {pavilion, stand} = this.props.match.params;
		Creators.loadGallery(pavilion, stand);
	}

	componentDidUpdate() {

		var standId = GalleryStore.getStandId();
		var data = GalleryStore.getData();

		if (standId != null && data == null) {
			Creators.loadGalleryId(standId);
		}
	}

	componentWillUnmount() {
		Creators.loadGallery(null, null);
	}

	play = (event) => {
		var ref = $(event.target).data('ref');

		var thumb = $('#thumb-' + ref);
		var play = $('#play-' + ref);
		var video = $('#video-' + ref);

		thumb.hide();
		play.hide();
		video.show();

		var player = new YT.Player('video-' + ref, {
			height: '480',
			width: '854',
			videoId: ref,
			playerVars: {'autoplay': 1},
			events: {
				'onReady': this.startPlay,
				'onStateChange': this.videoChanged
			}
		});
		Creators.setPlayer(player);
	};

	startPlay = (event) => {
		event.target.playVideo();
	};

	videoChanged = (event) => {
		if ([0, 2].includes(event.data)) {
			// 0 = stop; 2 = pause
			var ref = $(event.target.a).data('ref');
			var video = $('#video-' + ref);
			video.hide();
			var thumb = $('#thumb-' + ref);
			thumb.show();
			var play = $('#play-' + ref);
			play.show();
		}
	};

	render() {
		var {gallery_data} = this.state;
		var {pavilion, stand} = this.props.match.params;

		var imageElements = (gallery_data && gallery_data.standPhotos && gallery_data.standPhotos.length) ? gallery_data.standPhotos.map((image, i)=> {
			return (
				<div key={'i'+i}>
					<div className="image-container">
						<img src={image.imageUrl} alt={image.id}/>
						{image.description ?
							<div className="info-overlay bottom">
								<div className="text">{image.description}</div>
							</div>
							: null}
					</div>

				</div>
			);
		}) : [];


		var videoElements = (gallery_data && gallery_data.standVideos && gallery_data.standVideos.length) ? gallery_data.standVideos.map((video, i)=> {

			var thumbnail = 'https://img.youtube.com/vi/' + video.videoId + '/sddefault.jpg';

			return (
				<div key={'v'+i}>
					<div className="video-container">
						<img id={'thumb-' + video.videoId} alt={video.videoId} data-ref={video.videoId} src={thumbnail} onClick={this.play}/>
						<span id={'play-' + video.videoId} data-ref={video.videoId} onClick={this.play}/>
						<div id={'video-' + video.videoId} data-ref={video.videoId}/>
						{video.description ?
							<div className="info-overlay bottom">
								<div className="text">{video.description}</div>
							</div>
							: null}
					</div>
				</div>
			);
		}) : [];

		// Make sure to put videos first
		const galleryElements = [
			...videoElements.map((el, idx) => ({
				id: 'vid' + idx,
				content: el,
			})),
			...imageElements.map((el, idx) => ({
				id: 'img' + idx,
				content: el,
			})),
		];

		var standUrl = App.standUrl(pavilion, stand);

		return (
			<div className="gallery col-md-12">
				<SwiperFull
					items={galleryElements}
					backUrl={standUrl}
					slide={(item) => (
						<Element item={item}/>
					)}
				/>
			</div>
		);
	}

}

export default withRouter(Container.create(Gallery, {withProps: true}));



// WEBPACK FOOTER //
// ./src/modules/components/activities/gallery.js